module.exports = __webpack_public_path__ + "img/BR.4ebc22fb.png";